import { render, staticRenderFns } from "./Rarity.vue?vue&type=template&id=2add38e5&scoped=true"
import script from "./Rarity.vue?vue&type=script&lang=js"
export * from "./Rarity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2add38e5",
  null
  
)

export default component.exports